import { render, staticRenderFns } from "./esign-center-delete.vue?vue&type=template&id=98036cf2&scoped=true&"
import script from "./esign-center-delete.vue?vue&type=script&lang=js&"
export * from "./esign-center-delete.vue?vue&type=script&lang=js&"
import style0 from "./esign-center-delete.vue?vue&type=style&index=0&id=98036cf2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98036cf2",
  null
  
)

export default component.exports